import React from "react";
import { UseFormReturn } from "react-hook-form";

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Grid, Typography
} from "@mui/material";

import { t, Trans } from "@lingui/macro";


import {
    ZPlayFormField
} from "commons/fields";
import { ZPlayLoader } from "commons";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { withSnackbar, WithSnackbarProps } from "notistack";
import { Series } from "models";

export interface SeriesDetailsDataProps {
    name: string
    series: Series | null
}

export interface SeriesDetailsDataState {
    isLoading: boolean
}

class SeriesDetailsData extends React.Component<SeriesDetailsDataProps & UseFormReturn & WithSnackbarProps, SeriesDetailsDataState> {

    constructor(props: any) {

        super(props);

        this.state = {
            isLoading: false,
        };
    }

    render() {

        return (<>
            <Accordion sx={{ backgroundColor: process.env.REACT_APP_THIRD_COLOR }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                        <Trans id={"df-details-section"}>Dettagli</Trans>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container columnSpacing={3} alignItems="center">
                        {/*<Grid item xs={12} sm={6} md={4}>
                            <ZPlayAutocomplete
                                fieldName={`${this.props.name}.country`}
                                label={t({
                                    id: "df-country",
                                    message: "Paese di origine"
                                })}
                                formState={this.props.formState}
                                control={this.props.control}
                                trigger={this.props.trigger}
                                data={this.props.countryList} />
                        </Grid>*/}
                    </Grid>
                    <Grid container columnSpacing={3} rowSpacing={2}>
                        <Grid item xs={12} md={4}>
                            <ZPlayFormField
                                label={t({
                                    id: "df-production-year",
                                    message: "Anno di produzione"
                                })}
                                name={`${this.props.name}.productionYear`}
                                control={this.props.control}
                                formState={this.props.formState}
                                trigger={this.props.trigger}
                            />
                        </Grid>
                    </Grid>

                </AccordionDetails>
            </Accordion>
            {this.state.isLoading && <ZPlayLoader />}
        </>)
    }
}
export default withSnackbar(SeriesDetailsData);
